import { Component, Element, h, Method, Prop, State } from '@stencil/core';

@Component({
  tag: 'salla-login-modal',
  styleUrl: 'salla-login-modal.scss'
})


export class SallaLoginModal {
  constructor() {

    salla.event.on('login::open', (data) => {
      if (!this.isEmailAllowed && !this.isMobileAllowed) {
        salla.logger.warn('Please enable atleast one login type to use this component.');
        return;
      }
      this.withoutReload = data?.withoutReload ?? this.withoutReload;
      this.open(data);

      this.openModal();
    });

    salla.event.on('modal::close', (data) => {
      if (this.iframe) this.sendMessageToIframe({
        source: 'login',
        type: 'modal_closed',
        data,
      })
    })

    salla.onReady(() => {
      this.api = salla.config.get('store.api');
      this.storeId = salla.config.get('store.id');
    });
  }

  @Element() host: HTMLElement;
  /**
   * Does the merchant allow to login using email
   */
  @Prop({ mutable: true }) isEmailAllowed: boolean;
  /**
   * Does the merchant/current location for visitor allow to login using mobile, By default outside KSA is `false`
   */
  @Prop({ mutable: true }) isMobileAllowed: boolean = true;
  /**
   * Does the merchant require registration with email & mobile
   */
  @Prop({ mutable: true }) isEmailRequired: boolean = false;

  /**
   * Once the api verify success, it will be login the customer in web pages
   */
  @Prop({ reflect: true }) supportWebAuth: boolean = true;

  /**
   * Display the login inline
   */
  @Prop({ reflect: true }) inline: boolean;
  @Prop({ mutable: true }) storeId: string | number;
  @Prop() api: string;
  @Prop({ mutable: true }) headers: { [key: string]: string } | string;
  /**
   * Reload after a successful login
   */
  @Prop({ mutable: true }) withoutReload: boolean = false;

  private modal: HTMLSallaModalElement;

  private iframe: HTMLIFrameElement;
  private createPassKey: Window

  private htmlElement: HTMLElement = document.documentElement;

  @State() messages: object[] = [];
  @State() isClosable: boolean = true;
  @State() iframeLoaded: boolean = false;
  @State() scrolling: string = 'no';
  @State() direction: string = document.dir;
  @State() canRenderIframe: boolean = false;

  componentDidLoad() {
    window.addEventListener('message', (event) => {
      if (event.data.source != "login") {
        return;
      }

      salla.log(`salla-account:: recived an event`, event.data);
      let action = event.data.type.replace('iframe::', '');
      let value = event.data.message;

      //if we need skip some events
      // if (action === 'dispatchEvent' && [].includes(value.event)) {
      //     return;
      // }

      // if (action == "dispatchEvent") {
      //   return this.host.dispatchEvent(new CustomEvent(value.name, {
      //     cancelable: true,
      //     bubbles: true,
      //     detail: value.payload
      //   }));
      // }

      if (action == 'ready') {
        if (value.isPasskeyPage) {
          this.createPassKey.postMessage({ source: "login", type: "init_passkey_page", data: {
            token: salla.storage.get('token'),
            store_id: salla.config.get('store.id'),
            locale: salla.config.get('user.language_code'),
            redirect: salla.config.get('store.url')
          }}, salla.config.get('login.url'));

          return;
        }
        this.handleIframeReadyAction();
        return;
      }

      if (action == 'height') {
        return (this.iframe.height = value?.height + 'px');
      }

      //share the iframe storage, so login too
      if (action == "storage") {
        return this.handleIframeStorageAction(value);
      }
      // if (action == "success") {
      //   this.isClosable = true;
      //   confetti.startConfetti(1200, 50, 150);
      // }
      if (action == "scrolling") {
        this.scrolling = value;
        this.isClosable = false;
        return;
      }

      if (action == "direction") {
        return document.dir = this.direction = value ? "rtl" : "ltr";
      }

      if (action == 'notify') {
        return salla.notify[value.type](value.message);
      }

      // temporary condition until we handle both cases separately
      if (action == 'authenticated' || action == 'authenticated_web_auth') {
        !value?.withoutClose && this.modal.close()
        return salla.auth.api.handlAfterAuthenticatedResponse(value, this.supportWebAuth)
          .then(() => !(value?.withoutReload || this.withoutReload) && setTimeout(() => window.location.reload(), 1000));
      }

      if (action == 'dispatchEvent') {
        return salla.event.emit(value.event, ...value.payload);
      }

      if (action == 'reload') {
        if (value?.withClose) this.modal.close();
        return window.location.reload();
      }

      if (action === 'open_page') {
        return window.location.href = value.url;
      }

      if (action === 'open_passkey_page') {
        this.createPassKey = window.open(`${salla.config.get('login.url')}/create-passkey`);
        return;
      }


      if (action == "close") {
        this.modal.close();
        this.iframeLoaded = false;
        this.canRenderIframe = false;
        return this.host.dispatchEvent(new CustomEvent('salla-login:closed', {
          cancelable: true,
          bubbles: true,
          detail: null
        }));
      }
    });

    this.observeDarkModeChanges();
  }
  /**
   * Open login component
   */
  @Method()
  async open(_event = null) {
    /**
     * This is a workaround until we remove all the user objet from twig files
     * When the user is already login, let's reload the page
     */
    if (!salla.config.isGuest()) {
      if (!this.withoutReload) {
        return location.reload();
      }
      // Fire an event if withoutReload is true
      return;
    }

    return this.modal.open();
  }

  private handleIframeReadyAction() {
    this.sendInitMessage();

    this.sendMessageToIframe({
      source: 'login',
      type: 'width',
      data: document.body.clientWidth,
    });
  }

  private observeDarkModeChanges() {
    const observer: MutationObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation: MutationRecord) => {
        if (mutation.attributeName === 'class') {
          this.sendMessageToIframe({
            source: 'login',
            type: 'darkMode',
            data: { isDark: this.htmlElement.classList.contains('dark') ? true : false },
          });
        }
      });
    });

    // observing the HTML element for attribute changes
    observer.observe(this.htmlElement, { attributes: true });
  }
  private async handleIframeStorageAction(value:{user?:{id:string}, token?:string}) {
    let token, cartUserId = salla.storage.get('cart.user_id');
    Object.entries(value).filter(item => !salla.storage.get(item[0]))
      .forEach(([key, value]) => {
        salla.log('Shared storage from accounts domain', key, value);

        let cleanedValue:any = (typeof value === 'string') ? value.replace(/^"|"$/g, '') : value;

        salla.storage.set(key, cleanedValue);

        if (key === 'token') {
          token = cleanedValue;
        }

        if (key === 'user' && cartUserId && cleanedValue.id !== cartUserId) {
          salla.cart.reset();
        }
      });
      if (token) {
        this.modal.close();
        salla.auth.event.tokenFetched(token);
        !salla.auth.api.isSessionless() && await salla.auth.api.request('auth/jwt');
        setTimeout(() => window.location.reload(), 100);
        return;
      }
  }

  private sendMessageToIframe(message) {
    if (!this.iframe) return;
    return this.iframe.contentWindow.postMessage(message, '*');
  }

  private sendInitMessage() {
    let headers = this.headers;
    try {
      headers = typeof headers === 'string' ? JSON.parse(headers) : headers;
    } catch (error) {
      console.error('Failed to parse headers!', this.headers, error);
      headers = undefined;
    }

    const storageObject = {
        user:salla.storage.get('user'),
        s_translations:salla.storage.get('s_translations'),
        token:salla.storage.get('token'),
    };

    storageObject.user || (delete storageObject.user);
    storageObject.s_translations || (delete storageObject.s_translations);
    storageObject.token || (delete storageObject.token);

    this.sendMessageToIframe({
      source: "login",
      type: "init",
      data: {
        id: this.storeId,
        lang: salla.lang.locale,
        isDark: this.htmlElement.classList.contains('dark') ? true : false,
        apiUrl: this.api.replace(/\/+$/, ''),
        supportWebAuth: this.supportWebAuth,
        withoutReload: this.withoutReload,
        inline: this.inline,
        settings: salla.config.all(),
        headers: headers,
        storage: storageObject,
      }
    });
  }
  private openModal() {
    if (!this.canRenderIframe) {
      this.canRenderIframe = true;
    }

    this.modal.open();
  }

  render() {
    if (this.inline) {
      return this.getLoginDom();
    }
    return (
      <salla-modal class="s-login-modal" ref={modal => this.modal = modal} width="xs">
        {this.getLoginDom()}
      </salla-modal>
    );
  }

  private getLoginDom() {
    if (!this.canRenderIframe) return '';

    return <iframe src={salla.config.get('login.url', 'https://accounts.salla.com')}
      title="Salla Login"
      class="hide-scroll"
      loading='lazy'
      ref={iframe => { this.iframe = iframe }}
      allow="publickey-credentials-get; publickey-credentials-create"
      scrolling={this.scrolling}
      frameborder="0"
      width="100%"
    />
  }
}

